import * as React from 'react';
import * as isEqual from 'react-fast-compare';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat } from '../../classes/seat';
import { IPriceRangeModel } from '../../filter/reducers/filter-reducers';
import isMobile from '../../helpers/is-mobile';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import SeatHover from '../components/seat-hover';
import { ISeatMapModel } from '../reducers/seatmap-reducer';

let count = 0;

interface IMapProps {
    appSettings: IAppSettingsModel;
    seatMapModel: ISeatMapModel;
    dispatch: any;
    cartSeats: Array<CartSeat>;
    selectedPriceTypeFilter: Array<PriceType>;
    mapDragging: boolean;
}

interface IMapState {
    isChrome: boolean
}

class SvgMapHover extends React.Component<IMapProps, IMapState>{
    svgMap: any;
    transformLayer: any;

    constructor(props: IMapProps) {
        super(props);
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        this.state = {
            isChrome: isChrome
        };
    }

    shouldComponentUpdate(nextProps: IMapProps, nextState: IMapState) {
        return !nextProps.mapDragging &&
            this.props.selectedPriceTypeFilter.length !== nextProps.selectedPriceTypeFilter.length
            || this.props.cartSeats.length !== nextProps.cartSeats.length
            || (this.props.seatMapModel.seatsHovered.length == 0 || nextProps.seatMapModel.seatsHovered.length == 0 ? true
                : this.props.seatMapModel.seatsHovered[0].seatId !== nextProps.seatMapModel.seatsHovered[0].seatId)
            || !isEqual(this.props, nextProps);
    }

    render() {

        return (
            <svg className="hover-map-svg" viewBox="0 0 260 220" aria-labelledby="levelNameText">
                <g>
                    {
                        !this.props.appSettings.disableSeatHover && !isMobile() ?
                            <SeatHover
                                isChrome={this.state.isChrome}
                                showHover={!this.props.mapDragging && this.props.seatMapModel.seatHoverX !== null && this.props.seatMapModel.seatHoverY !== null}
                                xPosition={this.props.seatMapModel.seatHoverX} yPosition={this.props.seatMapModel.seatHoverY} appSettingsModel={this.props.appSettings} levelPricing={this.props.seatMapModel.allSeatPricing}
                                selectedPriceTypes={this.props.selectedPriceTypeFilter} cartSeats={this.props.cartSeats} seats={this.props.seatMapModel.seatsHovered} dispatch={this.props.dispatch} />
                            : null
                    }
                </g>

            </svg>
        );
    }


}

export default SvgMapHover;